import React, { useEffect, useRef, useState } from "react";
import style from "../banner/banner.module.css";
import PageHeader from "../../components/pageHeader/pageHeader";
import Table, { tableCustomStyles } from "../../components/CommonComponents/Table/Table";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../constants/Constants";
import { ErrorToast, SuccessToast } from "../../components/toastMessage";
import Modal from "react-bootstrap/Modal";
import cloudimg from '../../assets/images/svgs/cloud-upload-svgrepo-com.svg';
import { useDebounce } from "../../hooks/common";
import Paginator, { PaginatorForRDT } from "../../components/CommonComponents/Paginator/Paginator";
import Dropdown from 'react-bootstrap/Dropdown';
import uploadFileToBlob from "../../utils/azure-storage-blob";
import { useUser } from "../../contexts/UserContext";
import Edit from "../../assets/EditInWhite.svg";
import BoxComponent from "../../components/CommonComponents/BoxComponent/BoxComponent";
import { EditButton, ViewButton } from "../../components/CommonComponents/EditComponent/EditComponent";
import { _axios } from "../../utils/axios";
import { cookieUtils } from "../../utils/cookieUtils";
import { uploadFilesToServer } from "../../utils/fileUpload";

interface BannerItem {
  banner_id: string;
  image_url: string;
  start_date: Date | null;
  end_date: Date | null;
  status: boolean;
}

const Banner = () => {
  const [isGridView, setIsGridView] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [totalList, setTotalList] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const search = useDebounce(searchQuery);
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [btwStartDate, setBtwStartDate] = useState<string | null>(null);
  const [btwEndDate, setBtwEndDate] = useState<string | null>(null);
  const [activeStatus, setActiveStatus] = useState(false);
  const [inactiveStatus, setInactiveStatus] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showAddModal, setAddShowModal] = useState(false);
  const [file, setFile] = useState<any>()
  const [selectedItem, setSelectedItem] = useState<BannerItem | null>(null);
  const [selectedAddItem, setSelectedAddItem] = useState<BannerItem | null>(null);
  const [bannerList, setBannerList] = useState<Array<any>>([]);
  const [lgShow, setLgShow] = useState(false);
  const bannerRef = useRef<any>(null)
  const { state } = useLocation();
  const navigate = useNavigate();
  const documentData = state?.documentData;
  const [bannerData, setBannerData] = useState({
    banner_id: "",
    image_url: "",
    start_date: "",
    end_date: "",
    status: false,
  });
  const [formData, setFormData] = useState({
    banner_id: documentData?.banner_id ?? "",
    image_url: documentData?.image_url ?? "",
    status: documentData?.status === 1,
    start_date: documentData?.start_date ?? "",
    end_date: documentData?.end_date ?? "",
  });

  // const isUserLogin = async () => {
  //   const userDetails = await localStorage.getItem('userDetails');
  //   if (userDetails === null) {
  //     navigate('/onboarding/login');
  //   }
  // }
  const [userDetails, setUserDetails] = useState(null);

  const isUserLogin = async () => {
    const details = cookieUtils.getSecureCookie('userDetails');
    if (!details) {
      navigate('/onboarding/login');
    } else {
      setUserDetails(details);
    }
  };

  useEffect(() => {
    isUserLogin();
  }, []);

  // useEffect(() => {
  //   isUserLogin();
  // }, [navigate]);

  const handleFile = (e: any) => {
    setFile(e?.target?.files?.[0]);
  };

  const selectbannerDoc = () => {
    bannerRef?.current?.click()
  }


  const getBanner = () => {
    let statusFilter = null;

    // if (activeStatus && !inactiveStatus) {
    //   statusFilter = 1;
    // } else if (!activeStatus && inactiveStatus) {
    //   statusFilter = 0;
    // }
    _axios.post(`${BASE_URL}/api/banner/list`,
      {
        "page": currentPage,
        "limit": entriesPerPage,
        search: search,
        startDate,
        endDate,
        btwStartDate,
        btwEndDate,
        status: activeStatus ? 1 : (inactiveStatus ? 0 : null)
      })
      .then(function (response) {
        console.log('response', response);
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message)
          return
        }
        setTotalList(response.data.data.total_rows)
        setBannerList(response?.data?.data.results)
      })
      .catch(function (error: any) {
        // handle error
        if (error?.response?.data?.message) {
          ErrorToast(error?.response?.data?.message)
        }
        console.log('error', error);
      });
  }

  useEffect(() => {
    getBanner();
  }, [currentPage, search, startDate, endDate, btwStartDate, btwEndDate, activeStatus, inactiveStatus]);

  const formatDate = (dateString: any) => {
    if (!dateString) return '';
    const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  const columns = [
    {
      name: "Sr. No.",
      // selector: (row: any, rowIndex: number | undefined) =>
      //   (currentPage - 1) * entriesPerPage + (rowIndex ?? 0) + 1,
      selector: (log: any, rowIndex: number | undefined) => {
        const serialNumber = (currentPage - 1) * entriesPerPage + (rowIndex ?? 0) + 1;
        return serialNumber.toString().padStart(3, '0');
      },
      width: '100px',
      sortable: false,
    },
    {
      name: "Image",
      width: '300px',
      cell: (row: any) => (<div> <img height="120px" width="120px" alt="image" src={row.image_url} /> </div>),
      selector: (row: any) => (row.image_url),
      sortable: false,
    },
    {
      name: "Start Date",
      selector: (row: any) => formatDate(row.start_date ?? ''),
      sortable: true,
      width: "240px",
      grow: 3,
      sortFunction: (a: any, b: any) => {
        const dateA = new Date(a.start_date);
        const dateB = new Date(b.start_date);
        if (dateA.getFullYear() !== dateB.getFullYear()) {
          return dateA.getFullYear() - dateB.getFullYear();
        }
        if (dateA.getMonth() !== dateB.getMonth()) {
          return dateA.getMonth() - dateB.getMonth();
        }
        return dateA.getDate() - dateB.getDate();
      },
    },
    {
      name: "End Date",
      selector: (row: any) => formatDate(row.end_date ?? ''),
      sortable: true,
      width: "240px",
      grow: 3,
      sortFunction: (a: any, b: any) => {
        const dateA = new Date(a.end_date);
        const dateB = new Date(b.end_date);
        if (dateA.getFullYear() !== dateB.getFullYear()) {
          return dateA.getFullYear() - dateB.getFullYear();
        }
        if (dateA.getMonth() !== dateB.getMonth()) {
          return dateA.getMonth() - dateB.getMonth();
        }
        return dateA.getDate() - dateB.getDate();
      },
    },
    {
      name: "Status",
      cell: (row: any) => (
        <button
          className={row.status === 1 ? "activeButtonCss" : "inactiveButtonCss"}
        >
          {row.status === 1 ? "Active" : "Inactive"}
        </button>
      ),
      selector: (row: any) => row.status,
      width: "170px",
      sortable: true,
    },
    {
      name: 'Created By',
      selector: (row: any) => row.created_by,
      cell: (row: any) => <span className="text-center">{row.created_by}</span>,
      sortable: true,
      width: "170px",
    },
    {
      name: 'Created On',
      selector: (row: any) => formatDate(new Date(row.created_on)),
      sortable: true,
      width: "170px",
    },
    {
      name: 'Modified By',
      selector: (row: any) => row.modified_by,
      cell: (row: any) => <span className="text-center">{row.modified_by}</span>,
      sortable: true,
      width: "170px",
    },
    {
      name: 'Modified On',
      selector: (row: any) => formatDate(new Date(row.modified_on)),
      sortable: true,
      width: "170px",
    },
    {
      name: "Action",
      cell: (row: any) => (
        <div className="flex space-x-2">
          <EditButton
            onClick={() => handleEditClick(row)}
          />
          <ViewButton
            disabled={true}
            onClick={function (): void {
              throw new Error("Function not implemented.");
            }}
          />
        </div>
      ),
      sortable: false,
    },
  ];

  async function getNextAvailableId() {
    try {
      const response = await _axios.get(`${BASE_URL}/api/banner/next-banner-id`);
      return response.data.data.next_banner_id;
    } catch (error) {
      console.error('Error getting next available ID:', error);
      throw error;
    }
  }

  function formatDateTime(date: { getFullYear: () => any; getMonth: () => number; getDate: () => any; getHours: () => any; getMinutes: () => any; getSeconds: () => any; }) {
    const pad = (num: { toString: () => string; }) => num.toString().padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${year}${month}${day}-${hours}${minutes}${seconds}`;
  }

  // Create a banner-specific upload function
  const uploadBannerFilesToServer = async (filesObject: { [key: string]: any }, banner_id: string | number, container: string = 'banners') => {
    try {
      const formData = new FormData();
      formData.append('banner_id', String(banner_id)); // Use banner_id instead of user_id
      formData.append('container', container);

      let hasFiles = false;

      // Dynamically append all files from the filesObject
      for (const [fieldName, file] of Object.entries(filesObject)) {
        if (file && file instanceof File) {
          formData.append(fieldName, file);
          hasFiles = true;
          console.log(`Added ${fieldName}:`, file.name);
        }
      }

      if (!hasFiles) {
        throw new Error('No valid files to upload');
      }

      console.log('Uploading banner files to server with banner_id:', banner_id);

      const response = await _axios.post(`${BASE_URL}/api/banner/upload-files`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.success) {
        console.log('Banner upload response:', response.data);
        return response.data.urls;
      } else {
        throw new Error(response.data.message || 'Upload failed');
      }
    } catch (error) {
      console.error('Banner files upload error:', error);
      throw error;
    }
  };

  // Replace your existing addBanner function with this (with better error handling):
  async function addBanner(formData: any) {
    try {
      if (!file) {
        ErrorToast('Please select a file');
        return;
      }

      console.log('Starting banner creation process...');

      // Get the next available ID first
      const nextId = await getNextAvailableId();
      console.log('Retrieved next banner ID:', nextId);

      if (!nextId) {
        ErrorToast('Failed to get next banner ID');
        return;
      }

      // Upload file through backend using banner-specific function
      const filesToUpload = {
        banner_image: file
      };

      console.log('About to upload files with banner ID:', nextId);

      const uploadResult = await uploadBannerFilesToServer(
        filesToUpload,
        nextId,
        'banners'
      );

      console.log('File upload completed, result:', uploadResult);

      const image_url = uploadResult.banner_image;

      if (!image_url) {
        ErrorToast('Failed to upload banner image');
        return;
      }

      console.log('Creating banner record with image URL:', image_url);

      const response = await _axios.post(`${BASE_URL}/api/banner`, {
        banner_id: nextId,
        image_url: image_url,
        status: bannerData.status,
        start_date: bannerData.start_date,
        end_date: bannerData.end_date,
      });

      console.log('Banner added successfully:', response.data);
      SuccessToast('Banner added successfully');
      getBanner();

    } catch (error) {
      console.error('Error adding banner:', error);
      ErrorToast(`Failed to add banner: ${error || 'Unknown error'}`);
    }
  }

  const handleEditClick = (item: any) => {
    console.log("Edit button clicked:", item);
    const data = {
      banner_id: item.banner_id,
      image_url: item.image_url,
      start_date: new Date(item.start_date),
      end_date: new Date(item.end_date),
      status: item.status,
    };
    setSelectedItem(data);
    setShowModal(true);
  };

  async function editBanner(bannerId: string) {
    try {
      if (!selectedItem) {
        ErrorToast('No banner selected for editing');
        return;
      }

      console.log('Starting banner edit process for ID:', selectedItem.banner_id);

      let image_url = selectedItem.image_url; // Keep existing URL by default

      // If new file is selected, upload it through backend
      if (file) {
        console.log('New file selected, uploading...');

        const filesToUpload = {
          banner_image: file
        };

        const uploadResult = await uploadBannerFilesToServer(
          filesToUpload,
          selectedItem.banner_id,
          'banners'
        );

        image_url = uploadResult.banner_image;
        console.log('New image uploaded:', image_url);
        setFile(null);
      } else {
        console.log('No new file selected, keeping existing image URL');
      }

      // Send update request with all data (not FormData, just JSON)
      const updateData = {
        banner_id: selectedItem.banner_id,
        image_url: image_url,
        start_date: selectedItem.start_date ? new Date(selectedItem.start_date).toISOString().slice(0, 19).replace('T', ' ') : '',
        end_date: selectedItem.end_date ? new Date(selectedItem.end_date).toISOString().slice(0, 19).replace('T', ' ') : '',
        status: selectedItem.status ? '1' : '0'
      };

      console.log('Updating banner with data:', updateData);

      const response = await _axios.patch(`${BASE_URL}/api/banner/upload`, updateData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log('Banner updated successfully:', response.data);
      SuccessToast('Banner updated successfully');
      getBanner();

    } catch (error) {
      console.error('Error editing banner:', error);
      ErrorToast(`Failed to update banner: ${error || 'Unknown error'}`);
    }
  }


  const handleAddClick = (row: BannerItem | null) => {
    console.log("Add Button clicked:", row);
    setSelectedAddItem(row);
    setAddShowModal(true);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    // setSelectedItem(null);
    setSelectedItem;
    setFile(null);
    // Optionally reset other relevant state variables
  };

  const handleModalAddClose = () => {
    setAddShowModal(false);
    setSelectedAddItem(null);
    setLgShow(false);
    setFile(null);
    setBannerData({
      banner_id: "",
      image_url: "",
      start_date: "",
      end_date: "",
      status: false,
    });
    // Optionally reset other relevant state variables
  };

  const handleUpdateClick = () => {
    handleModalClose();
    setFile(null);
  };

  const handleUpdateClickAdd = () => {
    handleModalAddClose();
  };

  const handlePageChange = (page: React.SetStateAction<number>) => {
    setCurrentPage(page);
  };

  const handleInputChange = (e: { target: { name: string; value: string | boolean | any; }; }) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDateFilterChange = (type: string, date: string) => {
    if (type === 'afterStartDate') {
      setStartDate(date);
    } else if (type === 'beforeEndDate') {
      setEndDate(date);
    }

    getBanner();
  };

  const betDateFilterChange = (type: string, date: string) => {
    if (type === 'btwStartDate') {
      setBtwStartDate(date);
    } else if (type === 'btwEndDate') {
      setBtwEndDate(date);
    }
    getBanner();
  };

  const handleStatusChange = (status: string) => {
    if (status === "active") {
      setActiveStatus(!activeStatus);
      if (!activeStatus && inactiveStatus) {
        setInactiveStatus(false);
      }
    } else if (status === "inactive") {
      setInactiveStatus(!inactiveStatus);
      if (!inactiveStatus && activeStatus) {
        setActiveStatus(false);
      }
    }
    // getBanner();
  };

  const dropdownContent = (
    <div className={style.dropdownBox}>
      <ul>
        <Dropdown.Menu show className="align-left">
          <div className={style.dropContent}>
            <Dropdown.Header className={style.DropHeader}>Banner Upload filter</Dropdown.Header>
            <div className={style.dropdownCheck}>
              <input
                type="checkbox"
                className={style.checkBoxDrop}
                checked={activeStatus}
                onChange={() => handleStatusChange("active")}
              />
              <label className={style.DropLabel}>Active Status</label>
            </div>
            <div className={style.dropdownCheck}>
              <input
                type="checkbox"
                className={style.checkBoxDrop}
                checked={inactiveStatus}
                onChange={() => handleStatusChange("inactive")}
              />        <label className={style.DropLabel}>Inactive Status</label>
            </div>
            {/* <div className={style.dropdownContent}>
              <input
                type="date" placeholder="\u00A0"
                className={style.dropdownOption}
                onChange={(event) => handleDateFilterChange("afterStartDate", event.target.value)}
              />
              <label className={style.DropLabel}>After Start Date</label>
            </div>
            <div className={style.dropdownContent}>
              <input
                type="date" placeholder="\u00A0"
                className={style.dropdownOption}
                onChange={(event) => handleDateFilterChange("beforeEndDate", event.target.value)}
              />
              <label className={style.DropLabel}>Before End Date </label>
            </div>
            <div className={style.dropdownContent}>
              <input
                type="date"
                placeholder="Between start date"
                className={style.dropdownOptionBtw}
                onChange={(event) => betDateFilterChange("btwStartDate", event.target.value)}
              />
              <input
                type="date"
                placeholder="Between end date"
                className={style.dropdownOptionBtw}
                onChange={(event) => betDateFilterChange("btwEndDate", event.target.value)}
              />
              <label className={style.DropLabel}>Date Interval </label>
              <br />
            </div> */}
          </div>
        </Dropdown.Menu>
      </ul>
    </div>
  );

  const totalPages = Math.ceil(bannerList.length / entriesPerPage);
  const startIndex = (currentPage - 1) * entriesPerPage;
  const endIndex = startIndex + entriesPerPage;

  return (
    <div className="p-8 overflow-auto">
      {/* Main content here */}
      <PageHeader
        title="Banner Upload"
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        showSearchButton={false}
        showAdditionalButton={true}
        buttonTitle="Add Banner"
        onClick={() => setLgShow(true)}
        isGridView={isGridView}
        onGridIconClick={() => setIsGridView(!isGridView)}
        showFilterButton={true}
        dropdownContent={dropdownContent}
      />
      {isGridView ? (
        <>
          <BoxComponent>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
              {bannerList?.filter(
                (row: any) => row?.image_url.toLowerCase().includes(searchQuery.toLowerCase()))
                .map((row: any) => {
                  return (
                    <div className="p-4 sm:p-2 md:p-4 lg:p-4 xl:p-4 rounded-2xl bg-white flex flex-col shadow-lg border border-gray-300">
                      <div className="flex justify-between items-center space-x-4 mb-4">
                        {/* <button className={row.status === 1 ? style.activeButtonGrid : style.inactiveButtonGrid}> */}
                        <button className={row.status === 1 ? "activeButtonCss" : "inactiveButtonCss"}>
                          {row.status === 1 ? "Active" : "Inactive"}
                        </button>
                        <div className="flex justify-center space-x-1">
                          {/* <img src={Edit} alt="Edit" onClick={() => handleEditClick(row)} className="globalEditCss" /> */}
                          <EditButton
                            onClick={() => handleEditClick(row)}
                          />
                          <ViewButton
                            disabled={true}
                            onClick={function (): void {
                              throw new Error("Function not implemented.");
                            }}
                          />
                        </div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div >
                          <div>
                            <div className="d-flex flex-column p-1">
                              <p className="align-self-center text-sm md:text-base lg:text-lg" style={{ marginBottom: '0px' }}>
                                <strong>Start Date</strong>
                              </p>
                              <p className="align-self-center text-sm md:text-base lg:text-lg" style={{ marginBottom: '0px' }}>
                                {formatDate(row?.start_date ?? '-')}
                              </p>
                            </div>
                            <div className="d-flex flex-column p-1">
                              <p className="align-self-center text-sm md:text-base lg:text-lg" style={{ marginBottom: '0px' }}>
                                <strong>End Date</strong>
                              </p>
                              <p className="align-self-center text-sm md:text-base lg:text-lg" style={{ marginBottom: '0px' }}>
                                {formatDate(row?.end_date ?? '-')}
                              </p>
                            </div>
                          </div>

                        </div>
                        <img src={row.image_url} className={style.imgStyle} alt="img" />
                      </div>
                    </div>
                  )
                })
              }
            </div>
            <Paginator
              limit={entriesPerPage}
              page={currentPage}
              setPage={handlePageChange} // Update page state when page changes
              count={totalList || 0}
            />
          </BoxComponent>
        </>
      ) : (
        <BoxComponent>
          <Table
            columns={columns}
            data={bannerList}
            paginationTotalRows={totalList || 0}
            onChangePage={(p) => handlePageChange(p)} // Update page state when page changes
            customStyles={tableCustomStyles}
            paginationComponent={PaginatorForRDT}
          />
        </BoxComponent>
      )}

      {/* Add Modal */}
      <>
        <Modal
          size="lg"
          show={lgShow}
          onHide={() => setAddShowModal(false)}
          aria-labelledby="example-modal-sizes-title-vcenter-lg"
          centered
        >
          <div className={style.modalPd}>
            <Modal.Header>
              <div style={{ width: "100%" }}>
                <h5 className={style.popUpHeading}>Banner Upload</h5>
              </div>
            </Modal.Header>

            <Modal.Body>
              <p className={style.browseLabel}> Select Banner </p>
              <div className={style.uploadContainerDocument}>
                <label className={style.uploadLable} onClick={selectbannerDoc}>Browse</label>
                <small className={style.smallFont}><img src={file ? cloudimg : "Drag and Drop file here"} /></small>
                <input
                  id="image_url"
                  type="file"
                  ref={bannerRef}
                  name="image_url"
                  className={style.browseButton}
                  onChange={handleFile}
                  accept=".jpg, .png, image/jpeg, image/png"
                  onClick={() => handleInputChange({ target: { name: 'image_url', value: !bannerData.image_url } })}
                />
                <img src={file ? URL.createObjectURL(file) : cloudimg} alt="Logo" className={style.cloudUpload} />
              </div>

              <div className={style.dateWrapper}>
                <div className={`${style.dateItem}  ${style.dateInput}`}>
                  <label className={style.boldLable}>Start Date</label>
                  <input type="date" value={bannerData?.start_date}
                    onChange={(e) =>
                      setBannerData({ ...bannerData, start_date: e.target.value })
                    }
                    className="p-2" />
                </div>
                <div className={`${style.dateItem}  ${style.dateInput}`}>
                  <label className={style.boldLable}>End Date</label>
                  <input type="date" value={bannerData?.end_date} onChange={(e) =>
                    setBannerData({ ...bannerData, end_date: e.target.value })
                  }
                    className="p-2" />
                </div>
              </div>

              {/* Toggle button */}
              <div className={`${style.footerActive} mt-5`}>
                <label className={style.footerActive}>Activate Banner</label>
                <label className={style.toggleBtn}>
                  <input type="checkbox" checked={bannerData.status} className={style.inputCheckbox}
                    onChange={(e) =>
                      setBannerData({ ...bannerData, status: e.target.checked })
                    } />
                  <span className={style.slider}></span>
                </label>
              </div>
              <div className={style.buttonSection}>
                <button
                  // className={style.publishButton}
                  className="buttonCss"
                  onClick={() => {
                    if (file) {
                      addBanner(formData);
                      handleUpdateClickAdd();
                    }
                  }}
                >
                  Publish
                </button>

                <button
                  // className={style.closeButton}
                  className="closeButtonCss"
                  onClick={handleModalAddClose}>
                  Close
                </button>
              </div>
            </Modal.Body>
          </div>
        </Modal>
      </>

      {/* Edit */}
      {showModal && selectedItem && (
        <>
          <Modal
            size="lg"
            show={showModal}
            aria-labelledby="example-modal-sizes-title-vcenter-lg"
            centered
          >
            <div className={style.modalPd}>
              <Modal.Header>
                <div style={{ width: "100%" }}>
                  <h5 className={style.popUpHeading}>Banner Upload</h5>
                </div>
              </Modal.Header>

              <Modal.Body>
                <p className={style.browseLabel}> Select Banner </p>
                <div className={style.uploadContainerDocument}>
                  <button className={style.uploadLable} onClick={selectbannerDoc}>
                    Browse
                  </button>
                  <small className={style.smallFont}>
                    <img
                      src={selectedItem.image_url ? selectedItem.image_url : cloudimg}
                      style={{ width: '55px', height: '55px' }} // Adjust width and height as needed
                      alt="Uploaded Image"
                    />
                  </small>
                  {/* Display the newly uploaded image */}
                  {file && (
                    <img
                      src={URL.createObjectURL(file)}
                      style={{ width: '55px', height: '55px' }} // Adjust width and height as needed
                      alt="Uploaded Image"
                      className={style.cloudUpload}
                    />
                  )}
                  {/* Hidden file input */}
                  <input
                    id="image_url"
                    type="file"
                    ref={bannerRef}
                    name="image_url"
                    className={style.hiddenInput}
                    onChange={handleFile}
                    accept=".jpg, .png, image/jpeg, image/png"
                  />
                </div>

                <div className={style.dateWrapper}>
                  <div className={`${style.dateItem}  ${style.dateInput}`}>
                    <label className={style.boldLable}>Start Date</label>
                    <input
                      // className={style.inputSelect}
                      className="p-2"
                      type="date"
                      value={selectedItem.start_date ? selectedItem.start_date.toISOString().split('T')[0] : ''}
                      onChange={(e) => {
                        if (selectedItem) {
                          setSelectedItem({
                            ...selectedItem,
                            start_date: new Date(e.target.value),
                          });
                        }
                      }}
                    />
                  </div>
                  <div className={`${style.dateItem}  ${style.dateInput}`}>
                    <label className={style.boldLable}>End Date</label>
                    <input
                      // className={style.inputSelect}
                      className="p-2"
                      type="date"
                      value={selectedItem.end_date ? selectedItem.end_date.toISOString().split('T')[0] : ''}
                      onChange={(e) => {
                        if (selectedItem) {
                          setSelectedItem({
                            ...selectedItem,
                            end_date: new Date(e.target.value),
                          });
                        }
                      }}
                    />
                  </div>
                </div>

                {/* Toggle button */}
                <div className={`${style.footerActive} mt-5`}>
                  <label className={style.footerActive}>Activate Banner</label>
                  <label className={style.toggleBtn}>
                    <input
                      type="checkbox"
                      checked={selectedItem.status} // Check if status is 1
                      className={style.inputCheckbox}
                      onChange={(e) =>
                        setSelectedItem({
                          ...selectedItem,
                          status: e.target.checked ? true : false,
                        })
                      }
                    />
                    <span className={style.slider}></span>
                  </label>
                </div>
                <div className={style.buttonSection}>
                  <button
                    // className={style.publishButton}
                    className="buttonCss"
                    onClick={() => {
                      if (selectedItem) {
                        editBanner(selectedItem.banner_id);
                        handleUpdateClick();
                      }
                    }}>
                    Publish
                  </button>

                  <button
                    // className={style.closeButton}
                    className="closeButtonCss"
                    onClick={handleModalClose}>
                    Close
                  </button>
                </div>
              </Modal.Body>
            </div>
          </Modal>
        </>
      )}
    </div>
    // </div >
  );
};

export default Banner;
